import React, { Component } from "react"
import toast, { Toaster } from "react-hot-toast"

import { useForm } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import UserProfile from "components/UserProfile/UserProfile"
import { useHistory } from "react-router-dom"
import { useEffect, useState } from "react"
import { apiUrl } from 'config';
import logo from "assets/img/logo-color.png"
import background from "assets/img/trucks.jpg"

function Login() {
  const delay = (ms) => new Promise((res) => setTimeout(res, ms))
  const queryParams = new URLSearchParams(window.location.search)

  if (queryParams.get("logout")) {
    toast.error("Please login")
  }

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm()
  const history = useHistory()
  let user = localStorage.getItem("user")
  if (user) {
    history.push("/admin/dashboard")
  }

  const loginWithToken = async () => {
    if (queryParams.get("token")) {
      const toastId = toast.loading("Logging in...")
      let url = apiUrl + "admin/get_profile"

      let res = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer  " + queryParams.get("token"),
        }),
      })

      let resJson = await res.json()
      if (resJson.status) {
        toast.success(resJson.msg)
        toast.dismiss(toastId)
        await UserProfile.setUser(resJson.data)
        await delay(1000)
        history.push("/admin/dashboard")
      } else {
        toast.dismiss(toastId)
        toast.error(resJson.msg)
      }
    }
  }
  const onSubmit = async (data) => {
    const toastId = toast.loading("Logging in...")
    let url = apiUrl + "login"
    let formData = new FormData()
    formData.append("username", data.username)
    formData.append("password", data.password)

    let res = await fetch(url, {
      method: "POST",
      body: formData,
    })

    let resJson = await res.json()
    if (resJson.status) {
      toast.success(resJson.msg)
      toast.dismiss(toastId)
      await UserProfile.setUser(resJson.data)
      await delay(1000)
      history.push("/admin/dashboard")
    } else {
      toast.dismiss(toastId)
      toast.error(resJson.msg)
    }
  }
  const outlookLogin = async () => {
    const toastId = toast.loading("Logging in with outlook...")
    window.location.replace(apiUrl + "get_outlook_auth_url")
  }

  useEffect(() => {
    loginWithToken()
  }, [])

  return (
    <>
      <Toaster position='bottom-right' />
      <div
        className='Auth-form-container'
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
        }}
      >
        <form className='Auth-form' onSubmit={handleSubmit(onSubmit)}>
          <div className='Auth-form-content'>
            <div className='loginLogo'>
              <img src={logo} style={{ width: 200 }} alt='...' />
            </div>
            <br></br>
            <h3 className='Auth-form-title'>Login</h3>
            <p>Bus Sheet Calculator</p>
            <div className='form-group mt-3'>
              <label>Username</label>
              <input
                name='username'
                type='text'
                className='form-control mt-1'
                placeholder='Enter username'
                {...register("username", { required: "Username is required" })}
              />
            </div>
            <div className='form-group mt-3'>
              <label>Password</label>
              <input
                type='password'
                className='form-control mt-1'
                placeholder='Enter password'
                {...register("password", { required: "Password is required" })}
              />
            </div>
            <div className='buttons d-grid gap-2 mt-3'>
              <button type='submit' className='btn btn-primary'>
                Login
              </button>

              <button
                type='button'
                className='btn btn-primary'
                onClick={() => outlookLogin()}
              >
                Login with Outlook
              </button>
            </div>
            <br></br>
          </div>
        </form>
      </div>
    </>
  )
}

export default Login
